<template>
  <div class="hr-multiple-choice-questions">
    <div class="__title-container">
      <div v-if="title" class="__title">
        {{ title }}
        <sup class="__required-suffix">
          {{ suffix }}
        </sup>
      </div>
      <p v-html="helper" class="__helper"></p>
    </div>
    <co-select
      v-model="state.selected"
      is-mobile-friendly
      :placeholder="placeholder"
      :class="{
        'fs-mask': state.masked,
      }"
      @blur="validate"
    >
      <co-option
        v-for="item in options"
        is-mobile-friendly
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </co-select>
    <div v-if="state.field?.fieldError" class="__invalid">
      {{ state.field.fieldError }}
    </div>
  </div>
</template>
<script>
import { CoSelect, CoOption } from '@deputy/copilot2';
import { reactive, computed } from 'vue';
import { validateMultipleChoice } from '@/core/validation/common/custom-questions';
import { enableMask } from '@/core/fields-to-mask.js';

const DEFAULT_PLACEHOLDER = 'Select';

export default {
  name: 'hr-multiple-choice-questions',
  components: { CoSelect, CoOption },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:model-value'],
  setup(props, { emit }) {
    const state = reactive({
      field: computed(() => props.modelValue),
      selected: computed({
        get: () =>
          (state.field?.questionValue?.responses[0] || {}).answer || '',
        set: updateSelected,
      }),
      masked: enableMask(props.modelValue),
    });

    const placeholder = DEFAULT_PLACEHOLDER;
    const options = mapOptions();
    const suffix = state.field?.questionValue?.isRequired ? '*' : '';
    const title = state.field?.questionValue?.question;
    const helper = state.field?.questionValue?.description;

    function mapOptions() {
      if (!state.field.questionValue?.options) {
        return [];
      }
      return state.field.questionValue.options.map((item) => ({
        value: item,
        label: item,
        key: item,
      }));
    }

    function updateSelected(newValue) {
      if (!state.field.questionValue?.responses) {
        return [];
      }
      state.field.questionValue.responses[0] = {
        answer: newValue,
        comment: '',
      };
      state.field.value = state.field?.questionValue;
      validate();
      emit('update:model-value', state.field);
    }

    function validate() {
      state.field.fieldError = validateMultipleChoice(state.field);
    }

    return {
      state,
      options,
      title,
      helper,
      suffix,
      placeholder,
      validate,
      updateSelected,
    };
  },
};
</script>
<style scoped lang="scss">
.hr-multiple-choice-questions {
  margin-bottom: 4px;
}

.__title {
  font-weight: 600;
  color: var(--co-text-primary);
  margin-bottom: 4px;
}

.__helper {
  font-size: 14px;
  color: var(--co-text-secondary);
}

.__invalid {
  color: var(--co-text-attention);
  margin-top: 5px;
}

.__required-suffix {
  font-weight: 600;
  left: -0.3em;
  color: var(--co-text-primary);
}

@media only screen and (max-width: 768px) {
  .hr-multiple-choice-questions,
  .__helper,
  :deep(.co-input__inner),
  :deep(.co-input__inner:focus),
  .co-select-dropdown__item,
  .co-input--default {
    font-size: 16px;
  }
  .co-select-dropdown__wrap {
    margin: 0 !important;
  }
}
</style>
